
import { useEffect, useState } from 'react';
import './SectionComponent.css';
import ServicesCards from "../ServiceCard/ServiceCard"
import services from '../../assets/texts/cards/cards';
import Grow from '@mui/material/Grow';
import Grid from '@mui/material/Grid';

function ServicesSection({currentHash, clearServices}) {
    const [showText, setShowText] = useState(false)
    const [showServices, setShowServices] = useState(false)

    useEffect(()=>{
        if(clearServices){
            setShowText(false);
            setShowServices(false);
        }
    },[clearServices])

    useEffect(()=>{
        if(currentHash === 'servicios'){
            const t = setTimeout(() => {
                setShowText(true)
            }, 200);
            const t2 = setTimeout(() => {
                setShowServices(true)
            }, 250);
            return () => {
                clearTimeout(t);
                clearTimeout(t2);
            };
        }
        // if navigating away from servicios, we'll rely on clearServices prop
    }, [currentHash])

    return (
        <div id="servicios" className='App-section anchor_tags'>
            <Grow in={showText}>
                <div className="servicios_descripcion">
                    <h2>Servicios ofrecidos</h2>
                    Ofrecemos soluciones integrales de Recursos Humanos orientadas a potenciar el talento, optimizar procesos y acompañar el crecimiento de personas y organizaciones.
                </div>
            </Grow>
            <Grow in={showServices}>
                <div className="servicios_items">
                    <Grid className="servicios_item" container spacing={2} >
                        {
                            services.map((service)=>(<Grid size={{ xs: 6, md: 8 }}><ServicesCards title={service.title} description={service.description} icon={service.icon}/></Grid>))
                        }
                    </Grid>
                </div>
            </Grow>
        </div>
    );
}

export default ServicesSection;